import { getTextContent } from './get-text-content';
var indentLevels = {
    header: 0,
    sub_header: 1,
    sub_sub_header: 2
};
/**
 * Gets the metadata for a table of contents block by parsing the page's
 * H1, H2, and H3 elements.
 */
export var getPageTableOfContents = function (page, recordMap) {
    var toc = [];
    var pushToc = function (toc, block) {
        var _a;
        var type = block.type;
        if ((type === 'header' ||
            type === 'sub_header' ||
            type === 'sub_sub_header') &&
            // make sure they don't repeat
            toc.findIndex(function (b) { return b.id == block.id; }) == -1) {
            toc.push({
                id: block.id,
                type: type,
                text: getTextContent((_a = block.properties) === null || _a === void 0 ? void 0 : _a.title),
                indentLevel: indentLevels[type]
            });
        }
    };
    var handleToc = function (keys) {
        var _a, _b, _c;
        for (var _i = 0, _d = keys || []; _i < _d.length; _i++) {
            var blockId = _d[_i];
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            if (block) {
                var type = block.type;
                if (type == 'column_list') {
                    // find column
                    var column = (_b = block === null || block === void 0 ? void 0 : block.content) === null || _b === void 0 ? void 0 : _b.map(function (bId) { var _a; return (_a = recordMap.block[bId]) === null || _a === void 0 ? void 0 : _a.value; }).find(function (block) { return (block === null || block === void 0 ? void 0 : block.type) == 'column'; });
                    (_c = column === null || column === void 0 ? void 0 : column.content) === null || _c === void 0 ? void 0 : _c.forEach(function (blockId) {
                        var _a;
                        var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                        if (block)
                            pushToc(toc, block);
                    });
                }
                else {
                    pushToc(toc, block);
                }
                // recursively retrieve the headers and subheaders of other pages
                handleToc(block.content || []);
            }
        }
    };
    handleToc(page.content);
    var indentLevelStack = [
        {
            actual: -1,
            effective: -1
        }
    ];
    // Adjust indent levels to always change smoothly.
    // This is a little tricky, but the key is that when increasing indent levels,
    // they should never jump more than one at a time.
    for (var _i = 0, toc_1 = toc; _i < toc_1.length; _i++) {
        var tocItem = toc_1[_i];
        var indentLevel = tocItem.indentLevel;
        var actual = indentLevel;
        do {
            var prevIndent = indentLevelStack[indentLevelStack.length - 1];
            var prevActual = prevIndent.actual, prevEffective = prevIndent.effective;
            if (actual > prevActual) {
                tocItem.indentLevel = prevEffective + 1;
                indentLevelStack.push({
                    actual: actual,
                    effective: tocItem.indentLevel
                });
            }
            else if (actual === prevActual) {
                tocItem.indentLevel = prevEffective;
                break;
            }
            else {
                indentLevelStack.pop();
            }
            // eslint-disable-next-line no-constant-condition
        } while (true);
    }
    return toc;
};
//# sourceMappingURL=get-page-table-of-contents.js.map